import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Switch } from 'antd';
import classNames from 'classnames';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';
import style from './ComboItemsSwitch.module.scss';

const ComboItemsSwitch: React.FC = () => {
	const { toggleShowOnlyComboItems, isShowOnlyComboItems } = useContext<IModifiersContext>(ModifiersContext);

	const switchElementClass = classNames({ [style.switchActive]: isShowOnlyComboItems });

	return (
		<div className={style.container} data-test="ComboItemsSwitch">
			<Switch className={switchElementClass} checked={isShowOnlyComboItems} onChange={toggleShowOnlyComboItems} />
			<Text
				className={style.switchLabel}
				translationNameSpace="listing"
				translationKey="showOnlyComboItemsLabel"
				theme="neutralLight"
				weight="thin"
			/>
		</div>
	);
};

export default ComboItemsSwitch;
